import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { ProductsTypeEnum } from '@app/forms/subscription/definition/interface';
interface Owner {
  id: number;
  accountId?: number;
  startDate?: any;
  endDate?: any;
  label: string;
  relation?: string;
  current?: boolean;
}

@Component({
    selector: 'owner-selection',
    templateUrl: './owner-selection.component.html',
    styleUrls: ['./owner-selection.component.scss'],
    standalone: false
})
export class OwnerSelectionComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() ownerOptionsPhysical: Owner[];
  @Input() ownerCompanyOptions: Owner[];
  @Input() selectedSubmit: boolean;
  @Input() maxSelected: number;

  @Output() onSubmitEvent = new EventEmitter<void>();
  @Output() onPrevEvent = new EventEmitter<void>();

  isCristalisOrganization: boolean = false;
  cristalisOrganizationId: number = 251251251;
  productType: ProductsTypeEnum;

  constructor(
    private attributionDao: AttributionDao,
    public route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.attributionDao.getOrganization().subscribe((data: any) => {
      this.isCristalisOrganization = this.cristalisOrganizationId === data.id;
      this.productType = this.route.snapshot.queryParams.productType;
      console.log({ productType: this.productType });
    });
  }
  onSubmit() {
    this.onSubmitEvent.emit();
  }
  onPrev() {
    this.onPrevEvent.emit();
  }

  enabledPhysicalOwnerSelection(): boolean {
    if (!!this.isCristalisOrganization) {
      return false;
    }

    if (
      this.productType &&
      [ProductsTypeEnum.PEE, ProductsTypeEnum.PERCO].includes(this.productType)
    ) {
      return false;
    }

    return true;
  }
}
